import type {
	WaterAccount,
	WaterAccountAllocation,
	WaterAllocationTarget,
} from "@/shared/models/WaterAccount";

export interface WaterAccountAllocationDraft {
	WaterAccountId: number;
	IsActive: boolean;
	Allocations: { TargetId: number; AllocationPercent: number }[];
}

export interface WaterAccountAllocationRow {
	WaterAccountId: number;
	AccountNumber: string;
	Location: string | null;
	IsActive: boolean;
	PercentByTargetId: Record<number, number>;
	TotalPercent: number | null;
}

export const buildAllocationRows = (
	accounts: WaterAccount[],
	allocations: WaterAccountAllocation[],
): WaterAccountAllocationRow[] =>
	accounts.map((account) => {
		const own = allocations.filter(
			(allocation) => allocation.WaterAccountId === account.WaterAccountId,
		);

		const percentByTargetId: Record<number, number> = {};
		for (const allocation of own) {
			percentByTargetId[allocation.TargetId] = allocation.AllocationPercent;
		}

		return {
			WaterAccountId: account.WaterAccountId,
			AccountNumber: account.AccountNumber,
			Location: account.Location,
			IsActive: account.IsActive,
			PercentByTargetId: percentByTargetId,
			TotalPercent:
				own.length === 0
					? null
					: own.reduce(
							(total, allocation) => total + allocation.AllocationPercent,
							0,
						),
		};
	});

export const buildPercentByCode = (
	targets: WaterAllocationTarget[],
	allocations: WaterAccountAllocation[],
	waterAccountId: number,
): Record<string, number | null> => {
	const percentByCode: Record<string, number | null> = {};

	for (const target of targets) {
		const current = allocations.find(
			(allocation) =>
				allocation.WaterAccountId === waterAccountId &&
				allocation.TargetId === target.TargetId,
		);
		percentByCode[target.TargetCode] = current
			? current.AllocationPercent
			: null;
	}

	return percentByCode;
};
